export const monthNames = Object.freeze([
  { value: "January", text: "January", no: 1 },
  { value: "February", text: "February", no: 2 },
  { value: "March", text: "March", no: 3 },
  { value: "April", text: "April", no: 4 },
  { value: "May", text: "May", no: 5 },
  { value: "June", text: "June", no: 6 },
  { value: "July", text: "July", no: 7 },
  { value: "August", text: "August", no: 8 },
  { value: "September", text: "September", no: 9 },
  { value: "October", text: "October", no: 10 },
  { value: "November", text: "November", no: 11 },
  { value: "December", text: "December", no: 12 },
]);
